module.exports = {"username":"demo.kppbc2","id":"6","group":"beacukai","status":"enabled","detil":{"nama":"Demo Kppbc 2","nip":"232333232222323232","pangkat":"Pengatur Tk. I - II/d","kode_eselon2":"070000","eselon2":"Kanwil DJBC Jawa Timur I","kode_eselon3":"070300","eselon3":"KPPBC TMP B GRESIK","kantor":"KPPBC TMP B GRESIK","kantor_id":"070300","kantor_level":"eselon3"},"roleInfo":{"siroleg":[{"role":"siroleg.bc.analis","role_name":"Analis Beacukai","name":"siroleg","domains":"siroleg.beacukai.go.id","description":"Siroleg","icon":null}]}}


//////////////////
// WEBPACK FOOTER
// ./src/router/fake_tokens/token_kppbc2.json
// module id = h5rX
// module chunks = 10